export const FILE_ATTACH_TYPE = {
    MAIN: { value: 0, faName: 'اصلی' },
    GALLERY: { value: 1, faName: 'گالری' },
    AVATAR: { value: 2, faName: 'آواتار' },
    COVER: { value: 3, faName: 'کاور' },
    LOGO: { value: 4, faName: 'لوگو' },
    CERTIFICATE: { value: 5, faName: 'گواهی‌نامه' },
    DOCUMENT: { value: 6, faName: 'سند' },
    AROUND: { value: 7, faName: 'دور خودرو' },
    VIDEO: { value: 8, faName: 'ویدیو' },
    IMAGE: { value: 9, faName: 'تصویر' },
    OUTSIDE: { value: 10, faName: 'نمای بیرونی' },
    INSIDE: { value: 11, faName: 'نمای داخلی' },
    DAMAGE: { value: 12, faName: 'آسیب' },
    BEFORE: { value: 13, faName: 'قبل' },
    AFTER: { value: 14, faName: 'بعد' },
    BEHIND: { value: 15, faName: 'پشت' },
    LEFT: { value: 16, faName: 'چپ' },
    RIGHT: { value: 17, faName: 'راست' },
    OVER: { value: 18, faName: 'بالا' },
    NATIONAL_CARD_FRONT: { value: 19, faName: 'کارت ملی (تصویر رو)' },
    NATIONAL_CARD_BACK: { value: 20, faName: 'کارت ملی (تصویر پشت)' },
    BUSINESS_LICENSE: { value: 21, faName: 'جواز کسب' }
} as const;

export const ATTACHMENT_TYPE = {
    PRODUCT: { value: 0, faName: 'محصول' },
    USER: { value: 1, faName: 'کاربر' },
    VENDOR: { value: 2, faName: 'فروشنده' },
    ORDER: { value: 3, faName: 'سفارش' },
    INSPECTION: { value: 4, faName: 'بازرسی' },
    CONTENT: { value: 5, faName: 'محتوا' },
    BRAND: { value: 6, faName: 'برند' },
    CATEGORY: { value: 7, faName: 'دسته‌بندی' },
    STORE: { value: 8, faName: 'فروشگاه' }
} as const;
